exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ecommerce-nav[data-v-5011ef9a]::-webkit-scrollbar{width:.5rem;height:.5rem}.ecommerce-nav[data-v-5011ef9a]::-webkit-scrollbar-track{background:#e9ecef}.ecommerce-nav[data-v-5011ef9a]::-webkit-scrollbar-thumb{background:rgba(0,0,0,.2)}.ecommerce-nav[data-v-5011ef9a]::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.4)}.ecommerce-nav[data-v-5011ef9a]{overflow-x:auto;flex-shrink:0}.ecommerce-nav[data-v-5011ef9a] .nav-link{flex-shrink:0}", ""]);

// exports
